import { useEffect, useState } from "react";
import ApiCMS from "../../services/cms";
import Pagination from "../../components/pagination";
import Loading from "../../components/loading";
import Breadcrumb from "../../components/breadcrumb";
import { getStorage, setStorage } from "../../services/storageUtils";
import CardPill from "../../components/cards/card-pill";
import "./index.scss";

const ApiPills = ApiCMS();
const breadcrumb = [
  { label: "Início", href: "/inicio" },
  { label: "Conteúdo" },
];
const event = {
  name: "pill",
  category: "todas-as-pilulas",
  action: "click",
};

const AllPills = () => {
  const itemsPerPage = 9;
  const [pills, setPills] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = pills.slice(startIndex, endIndex);

  const getPills = () => {
    const keyStorage = "pilulas-de-conteudo-interna";
    const cachePillHome = getStorage(keyStorage, true);
    setLoading(true);
    if (cachePillHome) {
      setPills(cachePillHome);
      setLoading(false);
    } else {
      ApiPills.getAllPills(1, 99)
        .then((response) => {
          const { data } = response;
          setPills(data.results);
          setStorage(keyStorage, data.results, true);
        })
        .catch((error) => {
          console.warn("ERROR: ", error);
        })
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    getPills();
  }, []);

  return (
    <div className="all-pills">
      {loading ? (
        <Loading fullPage />
      ) : (
        <div className="container">
          <div className="wrapper-breadcrumb">
            <Breadcrumb items={breadcrumb} />
          </div>
          <h2>Pílulas de Conhecimento</h2>
          <p className="off-desktop">
            Conteúdos relevantes e personalizados, com dicas e orientações
            práticas baseados no perfil da sua empresa e na etapa em que você
            está.
          </p>
          <div className="content">
            {currentItems.length ? (
              <>
                <div className="all-pill-cards">
                  {currentItems.map((e) => (
                    <CardPill item={e} key={e.id} event={event} />
                  ))}
                </div>
                {currentItems.length > 9 && (
                  <div className="all-pills-container__pagination">
                    <Pagination
                      totalItems={pills.length}
                      itemsPerPage={itemsPerPage}
                      currentPage={currentPage}
                      onPageChange={setCurrentPage}
                    />
                  </div>
                )}
              </>
            ) : (
              <p>Não há conteúdos cadastrados.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AllPills;
